module.exports = __webpack_public_path__ + "static/media/dga.f585be43.jpg";